import React, { Component } from 'react';
import { FormattedMessage, injectIntl, FormattedHTMLMessage  } from 'react-intl';
import { Col, Row, Card, Nav, NavItem, NavLink } from 'reactstrap';


class PaymentManagementMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            error: [],
            block: false,
            menuList: [
                { tab: 'Charges', icon: <i className="far fa-credit-card mr-2" /> },
                { tab: 'Customers', icon: <i className="fas fa-users mr-2" /> },
                { tab: 'Events', icon: <i className="far fa-calendar-alt mr-2" /> },
                { tab: 'Payouts', icon: <i className="fas fa-exchange-alt mr-2" /> },
                { tab: 'PaymentLinks', icon: <i className="fas fa-link mr-2" /> }
            ]
        }
    }

    componentDidMount() {
    }

    render() {
        const { activeTab, toggleMenu } = this.props;

        
        return (
            <div >
                <Nav tabs vertical className="h-100 border-0">
                    <Card className="bg-white p-2 border-0 mb-3 shadow w-100" body>
                        <div className='d-flex'>
                            <h5 className='pl-3 mb-3'>
                                Shift4 Gateway
                            </h5>
                        </div>
                        
                        {this.state.menuList?.map(({ tab, icon }, index) => {
                            return (
                                <NavItem className="pb-2" key={index}>
                                    <NavLink className={activeTab === tab ? 'text-primary  border-0 pointer border-left-primary' : 'bg-white border-0 pointer'}
                                        onClick={() => { toggleMenu(tab); }} >
                                        <Row>
                                            <Col>{icon} <FormattedMessage id={`PaymentManagement.${tab}`} /></Col>
                                        </Row>
                                    </NavLink>
                                </NavItem>
                            )
                        })}
                    </Card>
                </Nav>
            </div>
        )
    }
}

export default injectIntl(PaymentManagementMenu);
